import { Suspense, memo } from 'react';
import { Routes, Route } from "react-router-dom";
import {
  Dashboard, RecommendationsAlerts, Login, Portfolio, Watchlist, OnBoarding, Settings, Orders, ForgotUserID,
  ForgotPassword, ForgetMpin, EnvironmentSetting, Calculator, MutualFunds, Register, Edis, OrderCart, AddendumReportsScreen, Ipo
} from '../screens';
import ProtectedRoute from './ProtectedRoute';
import ErrorBoundary from '../components/ErrorBoundary';
import HealthStatus from '../containers/HealthStatus';
import PopOutChart from '../containers/MarketOverview/PopOutChart';
import { LOCATIONS } from '../utils/global_variables';
import NotFound from '../containers/NotFound';


const Navigation = () => {
  return (
    // <BrowserRouter>  {/*   Ameersha N -- 24-07-2024 -- BrowserRouter has been moved to one step above which gives access for router-dom for all componenets -- Start */}
    <Routes>
      <Route path="addenddumreport" element={
        <ProtectedRoute>
          {/* BT-128486 Vinit Raut 19/02/2024 -- Error Boundary - Start */}
          <ErrorBoundary componentName="AddendumReportsScreen">
            <Suspense fallback="">
              <AddendumReportsScreen />
            </Suspense>
          </ErrorBoundary>
          {/* BT-128486 Vinit Raut 19/02/2024 -- Error Boundary - End */}
        </ProtectedRoute>
      }
      />
      <Route path="edis" element={
        <ProtectedRoute>
          {/* BT-128486 Vinit Raut 19/02/2024 -- Error Boundary - Start */}
          <ErrorBoundary componentName="Edis">
            <Suspense fallback="">
              <Edis />
            </Suspense>
          </ErrorBoundary>
          {/* BT-128486 Vinit Raut 19/02/2024 -- Error Boundary - End */}
        </ProtectedRoute>
      }
      />
      <Route path="dashboard" element={
        <ProtectedRoute>
          {/* BT-128486 Vinit Raut 19/02/2024 -- Error Boundary - Start */}
          <ErrorBoundary componentName="Dashboard">
            <Suspense fallback='' >
              <Dashboard />
            </Suspense>
          </ErrorBoundary>
          {/* BT-128486 Vinit Raut 19/02/2024 -- Error Boundary - End */}
        </ProtectedRoute>
      }
      />
      <Route path="portfolio" element={
        <ProtectedRoute>
          {/* BT-128486 Vinit Raut 19/02/2024 -- Error Boundary - Start */}
          <ErrorBoundary componentName="Portfolio">
            <Suspense fallback='' >
              <Portfolio />
            </Suspense>
          </ErrorBoundary>
          {/* BT-128486 Vinit Raut 19/02/2024 -- Error Boundary - End */}
        </ProtectedRoute>
      }
      />
      <Route path="watchlist" element={
        <ProtectedRoute>
          {/* BT-128486 Vinit Raut 19/02/2024 -- Error Boundary - Start */}
          <ErrorBoundary componentName="Watchlist">
            <Suspense fallback='' >
              <Watchlist />
            </Suspense>
          </ErrorBoundary>
          {/* BT-128486 Vinit Raut 19/02/2024 -- Error Boundary - End */}
        </ProtectedRoute>
      }
      />
      <Route path="orders" element={
        <ProtectedRoute>
          {/* BT-128486 Vinit Raut 19/02/2024 -- Error Boundary - Start */}
          <ErrorBoundary componentName="Orders">
            <Suspense fallback='' >
              <Orders />
            </Suspense>
          </ErrorBoundary>
          {/* BT-128486 Vinit Raut 19/02/2024 -- Error Boundary - End */}
        </ProtectedRoute>
      }
      />
      <Route path="setting" element={
        <ProtectedRoute>
          {/* BT-128486 Vinit Raut 19/02/2024 -- Error Boundary - Start */}
          <ErrorBoundary componentName="Settings">
            <Suspense fallback='' >
              <Settings />
            </Suspense>
          </ErrorBoundary>
          {/* BT-128486 Vinit Raut 19/02/2024 -- Error Boundary - End */}
        </ProtectedRoute>
      }
      />
      <Route path="recommendations" element={
        <ProtectedRoute>
          {/* BT-128486 Vinit Raut 19/02/2024 -- Error Boundary - Start */}
          <ErrorBoundary componentName="RecommendationsAlerts">
            <Suspense fallback='' >
              <RecommendationsAlerts />
            </Suspense>
          </ErrorBoundary>
          {/* BT-128486 Vinit Raut 19/02/2024 -- Error Boundary - End */}
        </ProtectedRoute>
      }
      />
      <Route path="calculator" element={
        <ProtectedRoute>
          {/* BT-128486 Vinit Raut 19/02/2024 -- Error Boundary - Start */}
          <ErrorBoundary componentName="Calculator">
            <Suspense fallback='' >
              <Calculator />
            </Suspense>
          </ErrorBoundary>
          {/* BT-128486 Vinit Raut 19/02/2024 -- Error Boundary - End */}
        </ProtectedRoute>
      }
      />
      {/* BT-128486 Vinit Raut 19/02/2024 -- Error Boundary - Start */}
      <Route path="onboarding" element={
        <ErrorBoundary componentName="OnBoarding">
          <Suspense fallback='' >
            <OnBoarding />
          </Suspense>
        </ErrorBoundary>
      }
      />
      {/* BT-128486 Vinit Raut 19/02/2024 -- Error Boundary - End*/}

      {/* BT-128486 Vinit Raut 19/02/2024 -- Error Boundary - Start */}
      <Route path="forgotUserId" element={
        <ErrorBoundary componentName="ForgotUserID">
          <Suspense fallback='' >
            <ForgotUserID />
          </Suspense>
        </ErrorBoundary>
      }
      />
      {/* BT-128486 Vinit Raut 19/02/2024 -- Error Boundary - End */}

      {/* BT-128486 Vinit Raut 19/02/2024 -- Error Boundary - Start */}
      <Route path="forgotPassword" element={
        <ErrorBoundary componentName="ForgotUserID">
          <Suspense fallback='' >
            <ForgotPassword />
          </Suspense>
        </ErrorBoundary>
      } />
      {/* BT-128486 Vinit Raut 19/02/2024 -- Error Boundary - End */}

      {/* BT-128486 Vinit Raut 19/02/2024 -- Error Boundary - Start */}
      <Route path="forgetMpin" element={
        <ErrorBoundary componentName="ForgetMpin">
          <Suspense fallback='' >
            <ForgetMpin />
          </Suspense>
        </ErrorBoundary>
      }
      />
      {/* BT-128486 Vinit Raut 19/02/2024 -- Error Boundary - End */}

      {/* BT-128486 Vinit Raut 19/02/2024 -- Error Boundary - Start */}
      <Route path="/mutualFunds" element={
        <ProtectedRoute>
          <ErrorBoundary componentName="MutualFunds">
            <Suspense fallback='' >
              <MutualFunds />
            </Suspense>
          </ErrorBoundary>
        </ProtectedRoute>
      }
      />
      <Route path={LOCATIONS.CHART} element={
        <ProtectedRoute>
          <ErrorBoundary componentName="TV Chart">
            <Suspense fallback='' >
              <PopOutChart />
            </Suspense>
          </ErrorBoundary>
        </ProtectedRoute>
      }
      />
      {/* BT-128486 Vinit Raut 19/02/2024 -- Error Boundary - End */}

      {/* BT-128486 Vinit Raut 19/02/2024 -- Error Boundary - Start */}
      <Route path="/register" element={
        <ErrorBoundary componentName="Register">
          <Suspense fallback='' >
            <Register />
          </Suspense>
        </ErrorBoundary>
      }
      />
      {/* BT-128486 Vinit Raut 19/02/2024 -- Error Boundary - End*/}

      {/* BT-128486 Vinit Raut 19/02/2024 -- Error Boundary - Start */}
      <Route path="environmentSetting" element={
        <ErrorBoundary componentName="EnvironmentSetting">
          <Suspense fallback='' >
            <EnvironmentSetting />
          </Suspense>
        </ErrorBoundary>
      }
      />
      {/* BT-128486 Vinit Raut 19/02/2024 -- Error Boundary - End */}

      {/* BT-128486 Vinit Raut 19/02/2024 -- Error Boundary - Start */}
      <Route path="/" element={
        <ErrorBoundary componentName="Login">
          <Suspense fallback='' >
            <Login />
          </Suspense>
        </ErrorBoundary>
      }
      />
      <Route path="orderCart" element={
        <ProtectedRoute>
          <Suspense fallback='' >
            <OrderCart />
          </Suspense>
        </ProtectedRoute>

      }
      />
      {/* BT-128486 Vinit Raut 19/02/2024 -- Error Boundary - End*/}
      {/* Parshva S: 14/6/24: Health status - Start */}
      <Route path="/healthcheck" element={
        <ErrorBoundary componentName="Health">
          <Suspense fallback='' >
            <HealthStatus />
          </Suspense>
        </ErrorBoundary>
      }
      />
      {/* Parshva S: 14/6/24: Health status - End */}

      {/* BREEZE : 3416 : IPO Responsive UI : ManasaB : 29-11-2024 : Ipo routing - Start */}
      <Route path="ipo" element={
        <ProtectedRoute>
          <ErrorBoundary componentName="Ipo">
            <Suspense fallback='' >
              <Ipo />
            </Suspense>
          </ErrorBoundary>
        </ProtectedRoute>
      }
      />
      {/* BREEZE : 3416 : IPO Responsive UI : ManasaB : 29-11-2024 : Ipo routing - End */}
      <Route path="*" element={<NotFound />} />
    </Routes>

    // </BrowserRouter> {/*   Ameersha N -- 24-07-2024 -- BrowserRouter has been moved to one step above which gives access for router-dom for all componenets -- End */}

  );
};

export default memo(Navigation);